export const GET_COURSE = 'dashboard/get_course';
export const ADD_TO_MY_COURSE = 'courses/add_to_my_course';